export default __webpack_public_path__ + "static/media/1stPanel.30595955.png";